import React from 'react'
import service_block_shape from '../../../assets/images/shape/service-block-shape.png';

const ServicesMainSection = () => {
  return (
    <>
      <section className="case-section bg-thm1 pt-120 pb-120">
        <div className="auto-container">
          <div className="row g-0">
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 78L32 30L48 58L60 42L84 78H12Z"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M32 30L40 46L48 58"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">GEO Technical Investigation</h4>
                    <p className="text text-clamp-3">
                      Geotechnical Investigation is a critical engineering
                      process required to evaluate subsurface soil and rock
                      conditions prior to the design and construction of any
                      structure. The need for this service arises from the
                      complex and variable nature of soil behavior underload,
                      environmental conditions, and long-term serviceability
                      requirements. Conducting a geotechnical investigation at
                      the early stage of a project is essential to achieving
                      safe, durable, and cost-effective engineering solutions.
                    </p>
                    <a
                      href="/service-detail/geotechnical-investigation"
                      className="btn-two-rounded"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="100ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 72L72 18"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M58 18H78V38"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M25 70H70"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">Calibration Services</h4>
                    <p className="text text-clamp-3">
                      Accurate measurement and precise instrumentation are the
                      backbone of quality control, safety, and operational
                      efficiency across all industries. Calibration Services
                      must ensure that instruments, equipment, and measuring
                      devices perform reliably and provide consistent,
                      traceable, and correct readings.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/calibration-services"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box border-0">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M36 12V36L22 70C20 76 24 84 31 84H65C72 84 76 76 74 70L60 36V12"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M34 12H62"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M30 66H66"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">Civil Testing</h4>
                    <p className="text text-clamp-3">
                      Soil is a naturally occurring material with highly
                      variable engineering properties that directly influence
                      the performance and safety of civil and structural works.
                      Soil Material Testing must figure out the physical,
                      mechanical, and chemical characteristics of soil to ensure
                      it is suitable for its intended engineering application.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/sub-services"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="500ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle
                        cx="42"
                        cy="42"
                        r="22"
                        stroke="black"
                        strokeWidth="5"
                      />
                      <path
                        d="M58 58L76 76"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M34 42H50"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M42 34V50"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">Non-Destructive Testing (NDT) </h4>
                    <p className="text text-clamp-3">
                      Non-Destructive Testing (NDT) is a critical quality
                      assurance and safety measure used to assess the integrity,
                      reliability, and performance of materials, structures, and
                      components without causing any damage. NDT is essential
                      for detecting flaws, defects, or discontinuities in
                      metals, concrete, composites, and industrial equipment
                      before they lead to failure.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/non-destructive-testing-ndt"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="500ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      {/* Clipboard */}
                      <rect
                        x="24"
                        y="18"
                        width="48"
                        height="60"
                        rx="4"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinejoin="round"
                      />

                      {/* Clipboard top */}
                      <path
                        d="M38 18H58V28H38V18Z"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinejoin="round"
                      />

                      {/* Check mark */}
                      <path
                        d="M36 48L44 56L60 40"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />

                      {/* Inspection lines */}
                      <path
                        d="M36 64H60"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />

                      <path
                        d="M36 34H52"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">Third-Party Inspection Services</h4>
                    <p className="text text-clamp-3">
                      Third-Party Inspection (TPI) is a critical service for
                      ensuring quality, compliance, and safety across
                      industrial, construction, and infrastructure projects. It
                      provides independent verification of products, materials,
                      equipment, and construction work, confirming that they
                      meet design specifications, contractual requirements, and
                      regulatory standards.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/third-party-inspection-services"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-md-6 col-xl-4 wow fadeInUp"
              data-wow-delay="500ms"
              data-wow-duration="1500ms"
            >
              <div className="service-block-two">
                <div className="inner-box">
                  <div className="icon">
                    <svg
                      width={96}
                      height={96}
                      viewBox="0 0 96 96"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18 24H78V68H18V24Z"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M32 78H64"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M48 68V78"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                      />
                      <path
                        d="M34 42L44 52L62 34"
                        stroke="black"
                        strokeWidth="5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <div className="content-box">
                    <h4 className="title">Inspection & Training Division</h4>
                    <p className="text text-clamp-3">
                      Lifting and Heavy Equipment Inspection services ensure the
                      safety, reliability, and compliance of cranes, hoists,
                      elevating platforms, and material handling equipment used
                      across industrial and construction projects. Our
                      inspections cover mobile cranes, crawler cranes, EOT
                      cranes, elevators, offshore lifting systems, boom trucks,
                      and specialized lifting accessories. We perform detailed
                      assessments in accordance with international safety
                      standards to help prevent operational failures, reduce
                      risks, and maintain safe working environments.
                    </p>
                    <a
                      className="btn-two-rounded"
                      href="/service-detail/inspection-and-training-division"
                    >
                      learn more
                    </a>
                  </div>
                  <div className="block-bg">
                    <img src={service_block_shape} alt="Image" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ServicesMainSection